import React from 'react';

import Box from '@mui/material/Box';

import { useStore } from 'utils/hooks/store';

import { UserCellAvatar, UserCellName, UserCellNameContainer, UserCellSelfIndicator } from './styles';

const UserCell: React.FunctionComponent<{ name: string; uuid: string }> = ({ name, uuid }) => {
  const { session } = useStore();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <UserCellAvatar name={name} size="small" />
      <UserCellNameContainer>
        <UserCellName id={`table-user-${name}`.replace(/ /g, '-').toLowerCase()} aria-label="user-name-cell">
          {name}
        </UserCellName>
        {session.user?.uuid === uuid ? <UserCellSelfIndicator>(You)</UserCellSelfIndicator> : null}
      </UserCellNameContainer>
    </Box>
  );
};
export default UserCell;
